import { render, staticRenderFns } from "./WaitingforCommercializingProposals.vue?vue&type=template&id=0f852b4c&"
import script from "./WaitingforCommercializingProposals.vue?vue&type=script&lang=js&"
export * from "./WaitingforCommercializingProposals.vue?vue&type=script&lang=js&"
import style0 from "./WaitingforCommercializingProposals.vue?vue&type=style&index=0&id=0f852b4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports